export enum ACTION {
  NEW = "NEW",
  EDIT = "EDIT",
  VIEW = "VIEW",
}

export enum RPA_TEMPLATE {
  TEMPLATE_1 = 1,
  TEMPLATE_2 = 2,
  TEMPLATE_3 = 3,
}

export interface IGenaralInfoRPA {
  rpaName?: string;
  customerId?: string;
  locationId?: string;
  unitId?: string;
}

export interface IRule {
  ruleKey: number;
  phase: PHASE;
  rpaTemplate?: RPA_TEMPLATE;
  dataTemplate?: IDataTemplate;
}

export interface IDataTemplate {
  id?: string;
  ruleName?: string;
  since?: string;
  rangeFrom?: number;
  rangeTo?: number;
  variableId?: string;
  otherVariableId?: string;
  conditionType?: string;
  comparision?: string;
  valueTemplate1?: string;
  valueTemplate2?: string;
  valueTemplate3?: string;
  calculationSign?: string;
  packageId?: string;
  action?: string;
  template?: number;
  execAfter?: string;
  execTime?: number;
  execTimeFormat?: string;
  endCheckingTime?: number;
  endCheckingTimeFormat?: string;
  orderNo?: number | null;
}

export const INIT_DATA_TEMPLATE: IDataTemplate = {
  id: null,
  ruleName: null,
  since: null,
  rangeFrom: null,
  rangeTo: null,
  variableId: null,
  otherVariableId: null,
  conditionType: null,
  comparision: null,
  valueTemplate1: null,
  valueTemplate2: null,
  valueTemplate3: null,
  calculationSign: "+",
  packageId: null,
  action: null,
  template: null,
  execAfter: null,
  execTime: null,
  execTimeFormat: "HOURS",
  endCheckingTime: null,
  endCheckingTimeFormat: "MINUTES",
};

export enum RPA_RULE_SINCE {
  RPA_RULE_SINCE_BEGINNING = "SINCE_BEGINNING",
  RPA_RULE_SINCE_RANGE = "SINCE_RANGE",
}

export enum RPA_RULE_COMPARISION_TYPE {
  COMPARISION_TYPE_DOWN = "DOWN",
  COMPARISION_TYPE_UP = "UP",
  COMPARISION_TYPE_NONE = "NONE",
  COMPARISION_TYPE_BOOL = "BOOL",
}

export enum RPA_RULE_COMPARISION_OPERATOR {
  OPERATOR_GT = ">",
  OPERATOR_GTE = ">=",
  OPERATOR_LT = "<",
  OPERATOR_LTE = "<=",
  OPERATOR_EQUAL = "=",
}

export enum RPA_RULE_EXECUTION_TIME {
  EXECUTION_AFTER_TIME = "AFTER_TIME",
  EXECUTION_INTERVAL = "INTERVAL",
  EXECUTION_INTERVAL_END_PHASE = "INTERVAL_END_PHASE",
}

export enum TIME_FORMAT {
  MINUTES = "MINUTES",
  HOURS = "HOURS",
}

export enum RPA_RULE_ACTION {
  ACTION_TECHNICAL_CHECKING = "TECHNICAL_CHECKING",
  ACTION_REACHING_SETPOINT = "REACHING_SETPOINT",
  ACTION_RECOUNT_TREATMENT = "RECOUNT_TREATMENT",
  ACTION_WAITING_TECHNICAL_CHECKING = "WAITING_TECHNICAL_CHECKING",
}

export enum PHASE {
  PHASE_1 = "PHASE_1",
  PHASE_2 = "PHASE_2",
  PHASE_3 = "PHASE_3",
  PHASE_4 = "PHASE_4",
  PHASE_OTHER = "PHASE_OTHER",
}
